let storeInstance = null;

export function createStore() {
  if (!storeInstance) {
    let state = $state({
      isConnectedToHotspot: false,
      macAddress: null,
      loading: true,
      loadingIndicator: false,
      node: "",
      isAuthenticatedOnHotspot: false,
      cellphone: null,
      state: "LANDING",
    });

    storeInstance = {
      get store() {
        return state;
      },
      setState(newState) {
        state.state = newState;
      },
      get state() {
        return state.state;
      },
      get cellphone() {
        return state.cellphone;
      },
      setCellphone(cellphone) {
        console.log("Setting cellphone to", cellphone);
        state.cellphone = cellphone;
      },
      async authenticate() {
        let cellphone = state.cellphone;
        let macAddress = state.macAddress;
      },
      get loadingIndicator() {return state.loadingIndicator; },
      set loadingIndicator(v) { state.loadingIndicator = v; },
    };
  }
  return storeInstance;
}

export function getStore() {
  if (!storeInstance) {
    storeInstance = createStore();
  }
  return storeInstance;
}

export const store = getStore();
